import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "POWERCOM";
const BASE = "https://www.powercom.srl";
const OG_IMAGE = `${BASE}/favicon.png`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function useSeo(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} — Telecomunicazioni & Impianti Tecnologici`;
    document.title = full;
    if (description) setMeta("name", "description", description);
    const url = BASE + pathname;
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:title", full);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", full);
    if (description) setMeta("name", "twitter:description", description);
    setLink("canonical", url);
  }, [pathname, title, description]);
}
